var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeatureTileIcon03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;fill:#D7DDDD;}\r\n\t.st2{fill:none;stroke:#FFFFFF;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:8;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    className: "st0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.01,
    y: 19.12,
    className: "st1",
    width: 27.96,
    height: 27.96
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2,0,0,2,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M10.21,21.48h11.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M18.52,21.48v-9.34c0-0.29,0.23-0.52,0.52-0.52h1.04c0.29,0,0.52,0.23,0.52,0.52v9.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M14.89,21.48v-6.23c0-0.29,0.23-0.52,0.52-0.52h1.04c0.29,0,0.52,0.23,0.52,0.52v6.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M11.25,21.48v-6.23c0-0.29,0.23-0.52,0.52-0.52h1.04c0.29,0,0.52,0.23,0.52,0.52v6.23"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureTileIcon03);
export default __webpack_public_path__ + "static/media/feature-tile-icon-03.233ad03c2d14154c27e25686e73bbb45.svg";
export { ForwardRef as ReactComponent };